import { useEffect } from "react";

const DEFAULTS = {
  title: "APM Fire Alarm Exam Prep — NICET Level 1 · 2 · 3 + NYC S-98",
  description:
    "140 hours of interactive fire alarm training for NICET candidates. NICET Level 1 Foundation + Level 2 + Level 3 + NYC FDNY S-98 Certificate of Fitness, AI tutor, QR-verified certificate. $149 lifetime.",
  image: "/og-image.png",
};

function setOrUpdateMeta(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    for (const [k, v] of Object.entries(attrs)) {
      if (k !== "content") el.setAttribute(k, v);
    }
    document.head.appendChild(el);
  }
  if ("content" in attrs) el.setAttribute("content", attrs.content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Apply per-page title + description + OG + Twitter + canonical meta tags.
 * Call with the page-specific overrides; everything else falls back to DEFAULTS.
 */
export function useDocumentMeta({ title, description, image, path } = {}) {
  useEffect(() => {
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    const pageTitle = title ? `${title} · APM Fire Alarm Exam Prep` : DEFAULTS.title;
    const pageDesc = description || DEFAULTS.description;
    const pageImage = image || DEFAULTS.image;
    const absImage = pageImage.startsWith("http") ? pageImage : `${origin}${pageImage}`;
    const url = `${origin}${path || (typeof window !== "undefined" ? window.location.pathname : "")}`;

    document.title = pageTitle;
    setOrUpdateMeta('meta[name="description"]', { name: "description", content: pageDesc });

    // Open Graph
    setOrUpdateMeta('meta[property="og:title"]', { property: "og:title", content: pageTitle });
    setOrUpdateMeta('meta[property="og:description"]', { property: "og:description", content: pageDesc });
    setOrUpdateMeta('meta[property="og:image"]', { property: "og:image", content: absImage });
    setOrUpdateMeta('meta[property="og:image:width"]', { property: "og:image:width", content: "1200" });
    setOrUpdateMeta('meta[property="og:image:height"]', { property: "og:image:height", content: "630" });
    setOrUpdateMeta('meta[property="og:url"]', { property: "og:url", content: url });
    setOrUpdateMeta('meta[property="og:type"]', { property: "og:type", content: "website" });
    setOrUpdateMeta('meta[property="og:site_name"]', { property: "og:site_name", content: "APM Fire Alarm Exam Prep" });

    // Twitter
    setOrUpdateMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    setOrUpdateMeta('meta[name="twitter:title"]', { name: "twitter:title", content: pageTitle });
    setOrUpdateMeta('meta[name="twitter:description"]', { name: "twitter:description", content: pageDesc });
    setOrUpdateMeta('meta[name="twitter:image"]', { name: "twitter:image", content: absImage });

    setCanonical(url);
  }, [title, description, image, path]);
}
